<template>
  <div>
    <VBrandLimitOfferListItem
      v-for="offer in brandLimitOffers.filter(offer => offer.copay_offer_id)"
      :key="offer.copay_offer_id"
      @remove="$emit('remove', offer)"
      :offer="offer"
      :isReadonly="isReadonly"
    ></VBrandLimitOfferListItem>
  </div>
</template>
<script>
  import VBrandLimitOfferListItem from "./VBrandLimitOfferListItem";

  export default {
    name: "VBrandLimitOfferList",
    components: { VBrandLimitOfferListItem },
    props: {
      brandLimitOffers: {
        required: true,
        type: Array
      },
      isReadonly: {
        required: true,
        type: Boolean
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VBrandLimitOfferList.vue